/**
 * Route for `custom-fraud-rule-engine-per-campaign-per-partner`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomFraudRuleEnginePerCampaignPerPartnerPage } from "../features/custom-fraud-rule-engine-per-campaign-per-partner/CustomFraudRuleEnginePerCampaignPerPartnerPage";

export const customFraudRuleEnginePerCampaignPerPartnerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-fraud-rule-engine-per-campaign-per-partner",
	component: CustomFraudRuleEnginePerCampaignPerPartnerPage,
});

export default customFraudRuleEnginePerCampaignPerPartnerRoute;
